import { render, staticRenderFns } from "./AdminFeedList.vue?vue&type=template&id=270f7a16&"
import script from "./AdminFeedList.vue?vue&type=script&lang=js&"
export * from "./AdminFeedList.vue?vue&type=script&lang=js&"
import style0 from "./AdminFeedList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports